<ngx3js-renderer
    [alpha]="true"
    [controlType]="'orbit'"
    [controlOptions]="{
        enablePan: false,
        enableZoom: false,
        autoRotate: false,
        autoRotateSpeed: 5
    }"
    (onRender)="onAnimate($event)"
    (mousemove)="onMouseMove($event)"
    #renderer3d
>
    <ngx3js-camera #camera>
        <ngx3js-position [x]="-50" [y]="0" [z]="-50"></ngx3js-position>
    </ngx3js-camera>

    <ngx3js-scene #scene>
        <!-- Luces -->
        <ngx3js-light
            [type]="'AmbientLight'"
            [color]="'#ffffff'"
            [intensity]="0.8"
        ></ngx3js-light>
        <ngx3js-light [type]="'DirectionalLight'" [intensity]="0.8">
            <ngx3js-position [x]="-3" [y]="10" [z]="-10"></ngx3js-position>
        </ngx3js-light>

        <!-- Cono -->
        <ngx3js-mesh #coneMesh>
            <ngx3js-geometry
                [type]="'cone'"
                [radius]="radius"
                [height]="1"
                [radialSegments]="64"
                [openEnded]="true"
            ></ngx3js-geometry>
            <ngx3js-material
                [type]="'meshphysical'"
                [color]="'#88ccee'"
                [transparent]="true"
                [opacity]="0.25"
                [metalness]="0.1"
                [roughness]="0"
                [reflectivity]="1"
                [clearcoat]="1"
                [clearcoatRoughness]="0"
                [side]="'DoubleSide'"
            ></ngx3js-material>
            <ngx3js-position
                [x]="0"
                [y]="(length * 1.05) / 2 + 0.5"
                [z]="0"
            ></ngx3js-position>
        </ngx3js-mesh>

        <!-- Cilindro transparente exterior -->
        <ngx3js-mesh #containerMesh>
            <ngx3js-geometry
                [type]="'cylinder'"
                [radiusTop]="radius"
                [radiusBottom]="radius"
                [height]="length * 1.05"
                [radialSegments]="64"
                [openEnded]="false"
            ></ngx3js-geometry>
            <ngx3js-material
                [type]="'meshphysical'"
                [color]="'#88ccee'"
                [transparent]="true"
                [opacity]="0.25"
                [metalness]="0.1"
                [roughness]="0"
                [reflectivity]="1"
                [clearcoat]="1"
                [clearcoatRoughness]="0"
                [side]="'DoubleSide'"
            ></ngx3js-material>
            <!-- <ngx3js-rotation [x]="mathPiValue / 2"></ngx3js-rotation> -->
        </ngx3js-mesh>

        <!-- Líquido -->
        <ngx3js-mesh
            *ngFor="let liquid of liquids; let i = index"
            #liquidMeshes
            [renderOrder]="i"
        >
            <ngx3js-geometry
                [type]="'cylinder'"
                [radiusTop]="radius * 0.95"
                [radiusBottom]="radius * 0.95"
                [height]="length * liquid.percentage"
                [radialSegments]="64"
                [heightSegments]="32"
                [openEnded]="false"
            ></ngx3js-geometry>
            <ngx3js-material
                [type]="'meshstandard'"
                [color]="liquid.color"
                [transparent]="true"
                [opacity]="0.6"
                [depthWrite]="false"
                [depthTest]="false"
                [side]="'DoubleSide'"
            ></ngx3js-material>
            <ngx3js-position
                [x]="0"
                [y]="getLiquidPosition(i) + 0.001 * i"
                [z]="0"
            ></ngx3js-position>
        </ngx3js-mesh>

        <ngx3js-mesh #measureLine *ngIf="allFig">
            <ngx3js-geometry
                [type]="'cylinder'"
                [radiusTop]="0.07"
                [radiusBottom]="0.07"
                [height]="length"
                [openEnded]="false"
            ></ngx3js-geometry>
            <ngx3js-material
                [type]="'meshphysical'"
                [color]="'#88ccee'"
                [transparent]="true"
                [opacity]="0.6"
                [depthWrite]="false"
                [depthTest]="false"
                [side]="'DoubleSide'"
            ></ngx3js-material>
            <ngx3js-position
                [x]="-(radius + 1) * gradeCos45"
                [y]="0"
                [z]="(radius + 1) * gradeSin45"
            ></ngx3js-position>
        </ngx3js-mesh>
        <ngx3js-mesh #measureLineGrowth *ngIf="allFig">
            <ngx3js-geometry
                [type]="'cylinder'"
                [radiusTop]="0.15"
                [radiusBottom]="0.15"
                [height]="length * percentageLine"
                [openEnded]="false"
            ></ngx3js-geometry>
            <ngx3js-material
                [type]="'meshphysical'"
                [color]="'#FFF900'"
                [transparent]="false"
                [opacity]="0.6"
                [depthWrite]="false"
                [depthTest]="false"
                [side]="'DoubleSide'"
            ></ngx3js-material>
            <ngx3js-position
                [x]="-(radius + 1) * gradeCos45"
                [z]="(radius + 1) * gradeSin45"
            ></ngx3js-position>
        </ngx3js-mesh>
        <ng-container *ngIf="allFig">
            <ngx3js-mesh *ngFor="let mark of getMeasurementMarks()" #marks>
                <ngx3js-geometry
                    [type]="'box'"
                    [width]="0.75"
                    [height]="0.1"
                    [depth]="0.1"
                ></ngx3js-geometry>
                <ngx3js-rotation
                    [y]="mathPiValue / 8"
                    [isRadian]="true"
                ></ngx3js-rotation>
                <ngx3js-material
                    [type]="'meshphysical'"
                    [color]="'#88ccee'"
                ></ngx3js-material>
                <ngx3js-position
                    [x]="-(radius + 1) * gradeCos45"
                    [y]="mark"
                    [z]="(radius + 1) * gradeSin45"
                ></ngx3js-position>
            </ngx3js-mesh>
        </ng-container>
        <ng-container *ngIf="allFig">
            <ngx3js-mesh *ngFor="let mark of getMeasurementMarks()">
                <ngx3js-geometry
                    [type]="'text'"
                    [text]="
                        (((mark + length / 2) / length) * 100).toFixed(0) + '%'
                    "
                    [size]="0.75"
                    [height]="0.05"
                    [font]="'/assets/fonts/helvetiker_regular.typeface.json'"
                ></ngx3js-geometry>
                <ngx3js-rotation
                    [y]="mathPiValue + mathPiValue / 8"
                    [isRadian]="true"
                ></ngx3js-rotation>
                <ngx3js-position
                    [x]="-(radius + 1) * gradeCos45 - 0.5"
                    [y]="mark - 0.25"
                    [z]="(radius + 1) * gradeSin45 + 0.5"
                ></ngx3js-position>
                <ngx3js-material
                    [type]="'meshBasic'"
                    [color]="'#ffffff'"
                ></ngx3js-material>
            </ngx3js-mesh>
        </ng-container>

        <ng-container *ngFor="let mark of getPercentageMarks(); let i = index">
            <ngx3js-mesh>
                <ngx3js-geometry
                    [type]="'cylinder'"
                    [radiusTop]="0.1"
                    [radiusBottom]="0.1"
                    [height]="4"
                    [openEnded]="false"
                    [center]="true"
                ></ngx3js-geometry>
                <!-- <ngx3js-rotation [z]="mathPiValue/2" [y]="(mathPiValue/8)* 3" [isRadian]="true"></ngx3js-rotation> -->
                <ngx3js-rotation
                    [z]="mathPiValue / 2"
                    [y]="(mathPiValue / 16) * 6"
                    [isRadian]="true"
                ></ngx3js-rotation>
                <ngx3js-material
                    [type]="'meshphysical'"
                    [color]="liquids[i]?.color"
                ></ngx3js-material>
                <ngx3js-position
                    [x]="radius * gradeCos45 - 2.5"
                    [y]="mark"
                    [z]="-(radius * 3) * gradeSin45"
                ></ngx3js-position>
            </ngx3js-mesh>
            <ngx3js-mesh>
                <ngx3js-geometry
                    [type]="'cone'"
                    [radius]="0.4"
                    [height]="1"
                    [radialSegments]="64"
                    [openEnded]="true"
                ></ngx3js-geometry>
                <ngx3js-rotation
                    [x]="-mathPiValue / 2"
                    [z]="-(mathPiValue / 16) * 2"
                    [isRadian]="true"
                ></ngx3js-rotation>
                <ngx3js-material
                    [type]="'meshphysical'"
                    [color]="liquids[i]?.color"
                ></ngx3js-material>
                <ngx3js-position
                    [x]="radius * gradeCos45 - 1.75"
                    [y]="mark"
                    [z]="-(radius * 3.5) * gradeSin45"
                ></ngx3js-position>
            </ngx3js-mesh>
        </ng-container>

        <ngx3js-mesh *ngFor="let mark of getPercentageMarks(); let i = index">
            <ngx3js-geometry
                [type]="'text'"
                [text]="(liquids[i]?.percentage * 100).toFixed(scalePercentage) + '%'"
                [size]="1"
                [height]="0.05"
                [font]="'/assets/fonts/helvetiker_regular.typeface.json'"
            ></ngx3js-geometry>
            <ngx3js-rotation
                [y]="-(mathPiValue / 16) * 10"
                [isRadian]="true"
            ></ngx3js-rotation>
            <ngx3js-position
                [x]="radius * gradeCos45 - 0.5"
                [y]="mark"
                [z]="-(radius * 4.5) * gradeSin45 + 0.13"
            ></ngx3js-position>
            <ngx3js-material
                [type]="'meshBasic'"
                [color]="liquids[i]?.color"
            ></ngx3js-material>
        </ngx3js-mesh>
        <ngx3js-mesh>
            <ngx3js-geometry
                [type]="'text'"
                [text]="title"
                [size]="1"
                [height]="0.05"
                [font]="'/assets/fonts/helvetiker_regular.typeface.json'"
                [center]="true"
            ></ngx3js-geometry>
            <ngx3js-rotation
                [y]="gradeCos45 * 4.25"
                [isRadian]="true"
            ></ngx3js-rotation>
            <ngx3js-material
                [type]="'meshBasic'"
                [color]="'#ffffff'"
            ></ngx3js-material>
            <ngx3js-position [y]="length / 2 + 3"></ngx3js-position>
        </ngx3js-mesh>
    </ngx3js-scene>
</ngx3js-renderer>

<!-- Tooltip -->
<div
    *ngIf="activeModal && tooltipVisible"
    class="tooltip-container"
    [ngStyle]="{
        top: tooltipY + 'px',
        left: tooltipX + 'px'
    }"
>
    <ng-content select="[data-body]"></ng-content>
</div>
